import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import { connect } from 'react-redux';
import {updateFilterSerial} from "scenes/Survey/Structure/data/filterSerial/actions";
import {Button, Card, CardBody, CardFooter, CardHeader, Input} from "reactstrap";
import SelectQuestions from "scenes/Survey/Structure/components/SelectQuestions";
import CheckAnswers from "scenes/Survey/Structure/components/CheckAnswers";
import CheckRows from "scenes/Survey/Structure/components/CheckRows";
import CheckColumns from "scenes/Survey/Structure/components/CheckColumns";
import ButtonDeleteFilterSerial from "../../../QuestionTo/components/FilterSerial/components/ButtonDeleteFilterSerial";
import FilterBySelect from "../../../FilterBySelect";
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import Select from "react-select";
import ButtonCopyFilterSerial from "../../../QuestionTo/components/FilterSerial/components/ButtonCopyFilterSerial";

class FilterSerial extends Component {

  constructor(props) {
    super(props);

    this.state = {
      edited: false,
      saving: false,
      editingName: false,
      deleting: false,
      filter: {
        id: props.filter.id,
        action: props.filter.action,
        hideQuestionToCondsMin: props.filter.hideQuestionToCondsMin,
        name: props.filter.name,
        questionFrom: {
          question: props.filter.questionFrom ? props.filter.questionFrom.question : null,
          answers: props.filter.questionFrom ? props.filter.questionFrom.answers : null,
          rows: props.filter.questionFrom ? props.filter.questionFrom.rows : null,
          columns: props.filter.questionFrom ? props.filter.questionFrom.columns : null,
          filterBy: props.filter.questionFrom ? props.filter.questionFrom.filterBy : null,
        },
        questionTo: {
          question: props.filter.questionTo ? props.filter.questionTo.question : null,
          filterBy: props.filter.questionTo ? props.filter.questionTo.filterBy : null,
        },
      }
    };

    this.saveFilter = this.saveFilter.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onQuestionFromFilterByChange = this.onQuestionFromFilterByChange.bind(this);
    this.onQuestionToFilterByChange = this.onQuestionToFilterByChange.bind(this);
    this.onElementsChange = this.onElementsChange.bind(this);
    this.onAnswersChange = this.onAnswersChange.bind(this);
    this.onRowsChange = this.onRowsChange.bind(this);
    this.onColumnsChange = this.onColumnsChange.bind(this);
    this.renderCafeterySelect = this.renderCafeterySelect.bind(this);
  }

  saveFilter() {
    this.setState({...this.state, saving: true, editingName: false});

    this.props.updateFilterSerial({surveyId: this.props.surveyId, filterSerial: this.state.filter})
      .then(() => this.setState({...this.state, edited: false, saving: false}));
  }

  onChange(e) {
    const filterByKeys = ['answers', 'rows', 'columns'];
    let questionTo = _.find(this.props.questions, question => question.id === e);
    const filterBy = _.find(filterByKeys, key => questionTo.hasOwnProperty(key));

    this.setState({
      ...this.state,
      edited: true,
      filter: {
        ...this.state.filter,
        questionTo: {
          filterBy, question: e
        }
      }
    });
  }

  onQuestionFromFilterByChange(filterBy) {
    this.setState({
      ...this.state,
      edited: true,
      filter: {
        ...this.state.filter,
        questionFrom: {
          ...this.state.filter.questionFrom,
          filterBy,
          answers: [],
          rows: [],
          columns: []
        }
      }
    });
  }

  onQuestionToFilterByChange(filterBy) {
    this.setState({
      ...this.state,
      edited: true,
      filter: {
        ...this.state.filter,
        questionTo: {
          ...this.state.filter.questionTo,
          filterBy
        }
      }
    });
  }

  onAnswersChange(answers) {
    this.onElementsChange(answers, 'answers')
  }

  onRowsChange(rows) {
    this.onElementsChange(rows, 'rows')
  }

  onColumnsChange(columns) {
    this.onElementsChange(columns, 'columns')
  }

  onElementsChange(elementsIds, elementsType) {
    this.setState({
      ...this.state,
      edited: true,
      filter: {
        ...this.state.filter,
        questionFrom: {
          ...this.state.filter.questionFrom,
          [elementsType]: elementsIds
        }
      }
    })
  }

  renderCafeterySelect(questionFrom) {
    switch (this.state.filter.questionFrom.filterBy) {
      case 'rows':
        return <CheckRows
          questionId={questionFrom.id}
          onChange={this.onRowsChange}
          checked={this.state.filter.questionFrom.rows}
        />;
      case 'columns':
        return <CheckColumns
          questionId={questionFrom.id}
          onChange={this.onColumnsChange}
          checked={this.state.filter.questionFrom.columns}
        />;
      case 'answers':
        return <CheckAnswers
          questionId={questionFrom.id}
          onChange={this.onAnswersChange}
          checked={this.state.filter.questionFrom.answers}
        />;
    }
  }

  render() {
    const {edited, saving} = this.state;

    const actionOptions = [
      {label: 'Pokaż', value: 1},
      {label: 'Ukryj', value: 2},
    ];

    let questionFrom = _.find(this.props.questions, question => question.id === this.state.filter.questionFrom.question);
    let questionTo = _.find(this.props.questions, question => question.id === this.state.filter.questionTo.question);
    let editor = <Input size="sm" className="mb-0" value={this.state.filter.name} onBlur={() => this.setState({editingName: false})} autoFocus={true} onChange={e => this.setState({edited: true, filter: {...this.state.filter, name: e.target.value}})} />;

    return (
      <Card className="border">
        <CardHeader className="border-bottom p-2 d-flex align-items-center">
          {this.state.editingName ? editor : <span onClick={() => this.setState({editingName: true})}>{this.state.filter.name || <i><FormattedMessage id="question.filterSerial.questionFrom.name.empty"/></i>}</span>}
          <div className="ml-auto pl-2 py-2">
            <ButtonDeleteFilterSerial filter={this.state.filter}/>
            <ButtonCopyFilterSerial filter={this.state.filter}/>
          </div>
        </CardHeader>
        <hr className="my-0" />
        <CardBody>
          <FilterBySelect filterQuestion={this.state.filter.questionFrom} onChange={this.onQuestionFromFilterByChange}/>

          <FormattedMessage id="question.filterSerial.questionFrom.questionTo.label"/>
          <div className="d-flex mb-2">
            <SelectQuestions
              className="w-100"
              enabledTypes={['single','multi', 'ranked', 'conjoint', 'matrix', 'matrixMulti', 'matrixDropdown', 'numericMulti']}
              disabledToPositionInSurvey={this.props.questions[this.state.filter.questionFrom.question].positionInSurvey}
              isMulti={false}
              isLoading={this.state.saving}
              onChange={this.onChange}
              value={questionTo ? questionTo.id : null}
            />
          </div>

          <Select
            className="mb-2"
            options={actionOptions}
            value={actionOptions.find(option => option.value == this.state.filter.action)}
            onChange={option => {
              this.setState({
                edited: true,
                filter: {
                  ...this.state.filter,
                  action: option.value,
                }
              })
            }}
          />

          {this.state.filter.action == 1 && <div className="d-flex flex-row align-items-center">
            <span>Pokaż pytanie jeśli respondent wybierze co najmniej</span>
            <Input className="mx-2" size="sm" type="number" style={{width: '50px'}} onChange={e => {
              this.setState({
                edited: true,
                filter: {
                  ...this.state.filter,
                  hideQuestionToCondsMin: e.target.value,
                }
              })

            }} value={this.state.filter.hideQuestionToCondsMin}/>
            <span>zaznaczonych poniżej odpowiedzi</span>
          </div>}

          {questionFrom && this.renderCafeterySelect(questionFrom)}
          <FilterBySelect filterQuestion={this.state.filter.questionTo} onChange={this.onQuestionToFilterByChange}/>
        </CardBody>
        {edited && <CardFooter>
          <LaddaButton
            className="btn btn-primary btn-ladda d-block mx-auto"
            loading={saving}
            data-style={ZOOM_OUT}
            onClick={this.saveFilter}
          >
            <i className="fas fa-save" /> Zapisz ustawienia
          </LaddaButton>
        </CardFooter>}
      </Card>
    )
  }
}

FilterSerial.propTypes = {
  filter: PropTypes.object.isRequired,
  surveyId: PropTypes.number.isRequired,
  questions: PropTypes.array.isRequired,
  filterBy: PropTypes.string
};

function mapStateToProps(state, props) {
  let questionFrom = null;

  if(props.filter.questionFrom.question){
    questionFrom = state.survey.structure.data.questions[props.filter.questionFrom.question];
  }

  return {
    questions: state.survey.structure.data.questions,
    answers: questionFrom ? _.filter(state.survey.structure.data.answers, element => element.question.id === questionFrom.id) : [],
    rows: questionFrom ? _.filter(state.survey.structure.data.rows, element => element.question.id === questionFrom.id) : [],
    columns: questionFrom ? _.filter(state.survey.structure.data.columns, element => element.question.id === questionFrom.id) : [],
  }
}

export default connect(mapStateToProps, {updateFilterSerial})(FilterSerial);
